'use client';

import { useIntl } from 'react-intl';
import { PageMetaData } from '@packages/modules/src/PageMetaData/PageMetaData';
import { CustomerOverview } from '@packages/order/src/components/CustomerOverview/CustomerOverview.client';
import { KimRating } from '@packages/modules/src/KimRating/KimRating.client';

const OverviewPage = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <PageMetaData page={{ type: 'myaccount', template: 'overview' }} />
      <h1>
        {formatMessage({
          id: 'CustomerOverview.accountTitle',
          defaultMessage: 'Mein Konto',
        })}
      </h1>
      <CustomerOverview />
      <KimRating pageType="myaccount" templateParams={{ x05: 'UEBER' }} />
    </>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default OverviewPage;
